import { render, staticRenderFns } from "./vacation-banner.vue?vue&type=template&id=31c7b651&"
import script from "./vacation-banner.vue?vue&type=script&lang=ts&"
export * from "./vacation-banner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports